import React from "react";

const LIGHTING_PRESETS = {
  day: {
    ambientIntensity: 0.25,
    hemisphereSkyColor: "#c7d8c0",
    hemisphereGroundColor: "#5c4a34",
    hemisphereIntensity: 0.4,
    directionalPosition: [1, 15, 5],
    directionalIntensity: 0.65,
    directionalColor: "#fff6df",
  },
  sunset: {
    ambientIntensity: 0.18,
    hemisphereSkyColor: "#e5a86a",
    hemisphereGroundColor: "#5a3b2b",
    hemisphereIntensity: 0.28,
    directionalPosition: [-6, 8, 6],
    directionalIntensity: 0.42,
    directionalColor: "#ffb46b",
  },
  night: {
    ambientIntensity: 0.15,
    hemisphereSkyColor: "#31425c",
    hemisphereGroundColor: "#161419",
    hemisphereIntensity: 0.05,
    directionalPosition: [10, 15, -3],
    directionalIntensity: 0.16,
    directionalColor: "#8ea8c7",
  },
  sunrise: {
    ambientIntensity: 0.16,
    hemisphereSkyColor: "#cfd8e8",      // cool early morning sky
    hemisphereGroundColor: "#5c4636",   // cool earth bounce
    hemisphereIntensity: 0.22,
    directionalPosition: [5, 4, -8],    // low sun angle (important)
    directionalIntensity: 0.38,
    directionalColor: "#ffd6a3",        // pale peach sunrise sun
  },
  storm: {
    ambientIntensity: 0.22,
    hemisphereSkyColor: "#7f8fa3",
    hemisphereGroundColor: "#4a3d33",
    hemisphereIntensity: 0.42,
    directionalPosition: [-2, 9, 4],
    directionalIntensity: 0.18,
    directionalColor: "#aab6c8",
  }
};

export default function Stage1PlantLighting({ mode = "day" }) {
  const preset = LIGHTING_PRESETS[mode] || LIGHTING_PRESETS.day;

  return (
    <>
      <ambientLight intensity={preset.ambientIntensity} />

      <hemisphereLight
        skyColor={preset.hemisphereSkyColor}
        groundColor={preset.hemisphereGroundColor}
        intensity={preset.hemisphereIntensity}
      />

      <directionalLight
        position={preset.directionalPosition}
        intensity={preset.directionalIntensity}
        color={preset.directionalColor}
        castShadow
        shadow-mapSize-width={2048}
        shadow-mapSize-height={2048}
        shadow-camera-near={0.1}
        shadow-camera-far={40}
        shadow-camera-left={-12}
        shadow-camera-right={12}
        shadow-camera-top={12}
        shadow-camera-bottom={-12}
      />
    </>
  );
}